import React from "react";

export default({
    iframeSrc,
    height = "50px"
}) => {
    return (<iframe src={iframeSrc} height={height} style={{margin: "0 auto"}}></iframe>);
};